import React from "react";
import Typography from "@material-ui/core/Typography";

const Label = ({ children, value = "- -", variant = "primary" }) => {
  if (variant !== "primary") {
    return (
      <Typography style={{ height: "30px" }}>
        <span style={{ color: "var(--text-primary)", fontWeight: "700" }}>
          {children}
        </span>
        {value + " "}
      </Typography>
    );
  }
  return (
    <Typography style={{ height: "30px" }}>
      <span style={{ color: "var(--text-primary)", fontWeight: "700" }}>
        {value + " "}
      </span>
      {children}
    </Typography>
  );
};

export default Label;
